import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "w-full",
  style: {"position":"relative"}
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "flex align-items-center" }
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = { style: {"padding-left":"2rem"} }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "flex justify-content-center align-items-center",
  style: {"width":"1.5rem"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "p-icon p-button-icon"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "text-sm font-italic text-red-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      lazy: "",
      paginator: "",
      rows: this.pagination.rows,
      onPage: $options.onPage,
      first: this.pagination.first,
      loading: $data.loading,
      totalRecords: this.pagination.totalRecords,
      dataKey: "id",
      value: this.reservedItems,
      filters: $data.filters,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (($data.filters) = $event)),
      onFilter: $options.onFilter,
      filterDisplay: "row",
      selection: this.selectedItem,
      "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((this.selectedItem) = $event)),
      stripedRows: "",
      "row-hover": "",
      selectionMode: "single",
      metaKeySelection: false,
      tableStyle: "min-width: 10rem",
      expandedRows: $data.expandedRows,
      "onUpdate:expandedRows": _cache[3] || (_cache[3] = ($event: any) => (($data.expandedRows) = $event))
    }, {
      expansion: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DataTable, {
            value: slotProps.data.items,
            dataKey: "id",
            stripedRows: "",
            "row-hover": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "code",
                header: "Kód"
              }),
              _createVNode(_component_Column, {
                field: "length",
                header: "Dĺžka"
              }),
              _createVNode(_component_Column, {
                field: "location",
                header: "Umiestnenie"
              }),
              _createVNode(_component_Column, {
                field: "numberOfItem",
                header: "Počet kusov",
                style: {"min-width":"1%"}
              }),
              (this.search)
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 0,
                    style: {"width":"23%"}
                  }, {
                    body: _withCtx((subSlotProps) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_PrimevueButton, {
                          onClick: ($event: any) => ($options.initOrders(slotProps.data.id,subSlotProps.index)),
                          label: "",
                          style: {"height":"2rem"},
                          class: "flex justify-content-between w-full",
                          outlined: "",
                          id: "item-order"
                        }, {
                          default: _withCtx(() => [
                            (subSlotProps.data.selectedOrder)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(subSlotProps.data.selectedOrder.orderCode), 1))
                              : _createCommentVNode("", true),
                            (!subSlotProps.data.selectedOrder)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Vyb. objed."))
                              : _createCommentVNode("", true),
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (subSlotProps.data.visibleSelect)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "card",
                              style: _normalizeStyle(`z-index: 10; position: absolute; top: 90px; left: ${this.vw*2/5-20}px; min-width: 20rem; transform-origin: center top; margin-top: 2px;`)
                            }, [
                              _createVNode(_component_IconField, {
                                iconPosition: "left",
                                class: "pl-1 pt-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_InputIcon, { class: "mr-1" }, {
                                    default: _withCtx(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_InputText, {
                                    modelValue: $data.orderFilters['global'].value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.orderFilters['global'].value) = $event)),
                                    placeholder: "Vyhľadať",
                                    onInput: ($event: any) => ($options.onOrderFilter(slotProps.data.id,subSlotProps.index))
                                  }, null, 8, ["modelValue", "onInput"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_DataTable, {
                                lazy: "",
                                paginator: "",
                                rows: subSlotProps.data.selectParams.rows,
                                onPage: ($event: any) => ($options.onOrderPage(slotProps.data.id,subSlotProps.index,$event)),
                                first: subSlotProps.data.selectParams.first,
                                loading: $data.selectLoading,
                                totalRecords: subSlotProps.data.selectParams.totalRecords,
                                dataKey: "id",
                                value: subSlotProps.data.orderOptions,
                                scrollHeight: `${200}px`,
                                virtualScrollerOptions: { itemSize: 40 },
                                stripedRows: "",
                                "row-hover": "",
                                scrollable: "",
                                selection: subSlotProps.data.selectedOrder,
                                "onUpdate:selection": ($event: any) => ((subSlotProps.data.selectedOrder) = $event),
                                selectionMode: "single",
                                metaKeySelection: false,
                                onRowSelect: ($event: any) => ($options.selectOrder(slotProps.data.id,subSlotProps.index)),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "ID",
                                    field: "orderCode",
                                    style: {"width":"5%"}
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Meno",
                                    field: "customer.lastName",
                                    style: {"width":"50%"}
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Obec",
                                    field: "customer.city",
                                    style: {"width":"45%"}
                                  })
                                ]),
                                _: 2
                              }, 1032, ["rows", "onPage", "first", "loading", "totalRecords", "value", "selection", "onUpdate:selection", "onRowSelect"])
                            ], 4))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (this.reserved)
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 1,
                    field: "numberOfReservedItems",
                    header: "",
                    style: {"min-width":"2%"}
                  }, {
                    body: _withCtx((slotProps) => [
                      (slotProps.data.packageId > 0)
                        ? _withDirectives((_openBlock(), _createBlock(_component_InputNumber, {
                            key: 0,
                            inputId: "numberOfReservedPieces",
                            useGrouping: false,
                            disabled: !(slotProps.data.selectedOrder) && this.search,
                            modelValue: slotProps.data[slotProps.field],
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data[slotProps.field]) = $event),
                            inputClass: `${slotProps.data.numberOfReservedItemIsWrong  ? 'bg-red-200 w-full' : 'w-full'}`,
                            invalid: slotProps.data.numberOfReservedItemIsWrong,
                            placeholder: "Rezer. kusy",
                            onInput: ($event: any) => ($options.handleInput(slotProps.data,$event))
                          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "inputClass", "invalid", "onInput"])), [
                            [
                              _directive_tooltip,
                              { value: 'Počet kusov k rezervácii' },
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (slotProps.data.numberOfReservedItemIsWrong)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Počet rezer. kusov je nesprávny "))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, {
                header: "",
                style: {"width":"2%"}
              }, {
                body: _withCtx((subSlotProps) => [
                  (this.reserved && subSlotProps.data.stockItemId > 0)
                    ? _withDirectives((_openBlock(), _createBlock(_component_PrimevueButton, {
                        key: 0,
                        type: "button",
                        icon: "pi pi-plus-circle",
                        severity: "success",
                        class: "pack reserve",
                        onClick: ($event: any) => ($options.confirmReserveStockItem(subSlotProps.data,true)),
                        text: "",
                        size: "large"
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          { value: 'Rezervovať' },
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("", true),
                  (!this.reserved && subSlotProps.data.stockItemId > 0)
                    ? _withDirectives((_openBlock(), _createBlock(_component_PrimevueButton, {
                        key: 1,
                        type: "button",
                        icon: "pi pi-times-circle",
                        severity: "danger",
                        class: "pack reserve",
                        onClick: ($event: any) => ($options.confirmReserveStockItem(subSlotProps.data,false)),
                        text: "",
                        size: "large"
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          { value: 'Zrušiť z rezervácie' },
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("", true),
                  (this.reserved && subSlotProps.data.packageId > 0)
                    ? _withDirectives((_openBlock(), _createBlock(_component_PrimevueButton, {
                        key: 2,
                        type: "button",
                        icon: "pi pi-plus-circle",
                        severity: "success",
                        class: "pack reserve",
                        onClick: ($event: any) => ($options.confirmReservePack(subSlotProps.data)),
                        text: "",
                        size: "large"
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          { value: 'Rezervovať' },
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("", true),
                  (!this.reserved && subSlotProps.data.packageId > 0)
                    ? _withDirectives((_openBlock(), _createBlock(_component_PrimevueButton, {
                        key: 3,
                        type: "button",
                        icon: "pi pi-times-circle",
                        severity: "danger",
                        class: "pack reserve",
                        onClick: _withModifiers(($event: any) => ($options.confirmDeleteReservePack(subSlotProps.data)), ["stop"]),
                        text: "",
                        size: "large"
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          { value: 'Zrušiť z rezervácie' },
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["value"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          expander: "",
          style: {"width":"1rem"}
        }),
        _createVNode(_component_Column, {
          header: "",
          style: {"width":"2rem"}
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("img", {
              src: `${slotProps.data.product.image}`,
              alt: slotProps.data.product.image,
              class: "shadow-4 border-round",
              height: "52"
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "",
          style: {"min-width":"1%"},
          filterField: "color",
          showFilterMenu: false,
          filterMenuStyle: { width: '1%' }
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "color-box mr-1",
                style: _normalizeStyle({ backgroundColor: slotProps.data.color.colorHash })
              }, null, 4),
              _createElementVNode("div", null, _toDisplayString(slotProps.data.color.code), 1)
            ])
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_PrimevueSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onChange: ($event: any) => (filterCallback()),
              options: this.colors,
              optionLabel: "code",
              placeholder: "Vyber farbu",
              class: "p-column-filter",
              style: {"min-width":"1%"}
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "color-box mr-1",
                    style: _normalizeStyle({ backgroundColor: slotProps.option.colorHash })
                  }, null, 4),
                  _createElementVNode("div", null, _toDisplayString(slotProps.option.code), 1)
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "product.code",
          header: "Kód",
          filterField: "product",
          showFilterMenu: false,
          filterMenuStyle: { width: '2%' },
          style: {"width":"2%"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.product.code), 1)
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            (!this.search)
              ? (_openBlock(), _createBlock(_component_PrimevueSelect, {
                  key: 0,
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  onChange: ($event: any) => (filterCallback()),
                  filter: "",
                  options: this.products,
                  optionLabel: "code",
                  placeholder: "Vyb. product",
                  class: "p-column-filter",
                  style: {"min-width":"2%"}
                }, {
                  option: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.option.code), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "options"]))
              : _createCommentVNode("", true),
            (this.search)
              ? (_openBlock(), _createBlock(_component_InputText, {
                  key: 1,
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  type: "text",
                  onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                  class: "p-column-filter",
                  placeholder: "Hľadať",
                  style: {"min-width":"5rem"}
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "product.name",
          header: "Názov"
        }),
        (!this.search)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              field: "product.category.name",
              header: "Kategória",
              filterField: "category",
              showFilterMenu: false,
              filterMenuStyle: { width: '3%' },
              style: {"min-width":"3%"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.product.category.name), 1)
              ]),
              filter: _withCtx(({ filterModel, filterCallback }) => [
                _createVNode(_component_PrimevueSelect, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  onChange: ($event: any) => (filterCallback()),
                  options: this.categories,
                  optionLabel: "name",
                  placeholder: "Vyb. kateg.",
                  class: "p-column-filter",
                  style: {"min-width":"3%"}
                }, {
                  option: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.option.name), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          field: "numberOfItem",
          header: "Počet kusov"
        })
      ]),
      _: 1
    }, 8, ["rows", "onPage", "first", "loading", "totalRecords", "value", "filters", "onFilter", "selection", "expandedRows"])
  ]))
}